import type { FaireProductEntity } from "../../entity_types/product";

export const p_kn57gnu33x: FaireProductEntity = {
  token: "p_kn57gnu33x",
  type: "product",
  name: "birthday things greeting card",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/d3067cbb6f64c276e58c46921e1e6b67161ce93ffa6159fd57f85282dadb08c1.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.5,
  description:
    'The birthday things card is blank inside with charming watercolor illustrations of dad\'s favorite things on the front.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• card + envelope\n• 5.5" x 4.25"\n• printed on 120lb superfine paper',
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:10.976Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
